import type { Card } from '../../interfaces/ICardItem';

export class LoadSalData {
    static readonly type = '[Sal Data] Load sal data';

    constructor(public payload: { lang: string }) {}
}

export class AddSalData {
    static readonly type = '[Sal Data] Add sal data';

    constructor(public payload: { data: Card }) {}
}

export class UpdateSalData {
    static readonly type = '[Sal Data] Update sal data';

    constructor(public payload: { data: Card }) {}
}

export class DeleteSalData {
    static readonly type = '[Sal Data] Delete sal data';

    constructor(public payload: { id: number }) {}
}
